import type { BarcodeScanner, BarcodeScanOptions } from "./barcode-scanner";
import { BrowserBarcodeDetectorScanner } from "./browser-barcode-detector";
import { ZxingBarcodeScanner } from "./zxing-barcode-scanner";

export class AdaptiveBarcodeScanner implements BarcodeScanner {
  constructor(
    private readonly nativeScanner = new BrowserBarcodeDetectorScanner(),
    private readonly fallbackScanner = new ZxingBarcodeScanner(),
  ) {}

  isSupported(): Promise<boolean> {
    return this.fallbackScanner.isSupported();
  }

  async scan(video: HTMLVideoElement, options?: BarcodeScanOptions): Promise<string> {
    return await this.nativeScanner.isSupported()
      ? this.nativeScanner.scan(video, options)
      : this.fallbackScanner.scan(video, options);
  }
}

